var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { staticClass: "atmo-nested-section p-2" },
    [
      _c("text-header", { attrs: { "margin-class": "mb-3" } }, [
        _vm._v("Создание дополнительного соглашения"),
      ]),
      _c(
        "b-overlay",
        {
          attrs: {
            show: _vm.isDataSending,
            opacity: "0.6",
            rounded: "",
            "spinner-variant": "primary",
          },
        },
        [
          _c("text-row-proposal-specification-table", {
            attrs: {
              "without-vat": _vm.purchase.supplier_proposal.without_vat,
            },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function () {
                  return [
                    _c(
                      "h5",
                      {
                        staticClass:
                          "grey-color ml-1 mb-1 main_text font-weight-bold",
                      },
                      [_vm._v("Спецификация контракта")]
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _vm.purchase.supplier_proposal.deliverables,
              callback: function ($$v) {
                _vm.$set(_vm.purchase.supplier_proposal, "deliverables", $$v)
              },
              expression: "purchase.supplier_proposal.deliverables",
            },
          }),
          _c("text-row-price", {
            attrs: {
              label: "Стоимость контракта",
              compact: "",
              "label-cols-lg": 4,
            },
            model: {
              value: _vm.purchase.purchase_terms.contract_price,
              callback: function ($$v) {
                _vm.$set(_vm.purchase.purchase_terms, "contract_price", $$v)
              },
              expression: "purchase.purchase_terms.contract_price",
            },
          }),
          _c("form-row-edit-price", {
            attrs: {
              v: _vm.$v.form.price,
              label: "Стоимость контракта с учетом дополнительного соглашения",
              "label-cols-lg": 4,
            },
            model: {
              value: _vm.form.price,
              callback: function ($$v) {
                _vm.$set(_vm.form, "price", $$v)
              },
              expression: "form.price",
            },
          }),
          _c("form-row-edit-date", {
            attrs: {
              label: "Дата заключения дополнительного соглашения",
              v: _vm.$v.form.conclusion_date,
              "min-date": _vm.purchase.contract.contract_conclusion_date,
              "max-date": _vm.$now(),
              "label-cols-lg": 4,
            },
            model: {
              value: _vm.form.conclusion_date,
              callback: function ($$v) {
                _vm.$set(_vm.form, "conclusion_date", $$v)
              },
              expression: "form.conclusion_date",
            },
          }),
          _c("form-row-single-line-document-upload", {
            attrs: {
              v: _vm.$v.form.attachment,
              title: "Дополнительное соглашение",
              "label-cols-lg": 4,
            },
            model: {
              value: _vm.form.attachment,
              callback: function ($$v) {
                _vm.$set(_vm.form, "attachment", $$v)
              },
              expression: "form.attachment",
            },
          }),
        ],
        1
      ),
      _c(
        "b-overlay",
        {
          staticClass: "d-inline-block",
          attrs: {
            show: _vm.isDataSending,
            opacity: "0.6",
            rounded: "",
            "spinner-small": "",
            "spinner-variant": "primary",
          },
        },
        [
          _c(
            "b-button",
            {
              staticClass: "text-uppercase mt-1 mr-3",
              attrs: { variant: "custom-outline-secondary" },
              on: {
                click: function ($event) {
                  return _vm.$emit("cancel")
                },
              },
            },
            [_vm._v("Отмена")]
          ),
          _c(
            "b-button",
            {
              staticClass: "text-uppercase mt-1",
              attrs: { variant: "custom-green", disabled: _vm.$v.$invalid },
              on: { click: _vm.sendSupplementaryAgreement },
            },
            [_vm._v("Отправить дополнительное соглашение поставщику")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }